export const CREATE_EXPENSE_MUTATION = `
  mutation CreateExpense($object: expense_requests_insert_input!) {
    insert_expense_requests_one(object: $object) {
      id
      expense_type_id
      company_id
      user_id
      status
      expense_date
      amount
      description
      created_at
      user {
        id
        first_name
        last_name
      }
      expense_type {
        id
        expense_type_name
      }
    }
  }
`;

export const APPROVE_EXPENSE_MUTATION = `
  mutation ApproveExpense($id: Int!, $updateFields: expense_requests_set_input!) {
    update_expense_requests_by_pk(pk_columns: {id: $id}, _set: $updateFields) {
      id
      status
      approving_manager_id
      approving_date
      approving_manager {
        first_name
        last_name
      }
    }
  }
`;

export const REJECT_EXPENSE_MUTATION = `
  mutation RejectExpense($id: Int!, $updateFields: expense_requests_set_input!) {
    update_expense_requests_by_pk(pk_columns: {id: $id}, _set: $updateFields) {
      id
      status
      reject_reason
      approving_manager_id
      approving_date
      approving_manager {
        first_name
        last_name
      }
    }
  }
`;

export const UPDATE_EXPENSE_PAYMENT_MUTATION = `
  mutation UpdateExpensePayment($id: Int!, $paidAmount: numeric!) {
    update_expense_requests_by_pk(pk_columns: {id: $id}, _set: {paid_amount: $paidAmount}) {
      id
      paid_amount
      amount
      status
    }
  }
`; 